import { render, staticRenderFns } from "./RatesForm.vue?vue&type=template&id=54d1e91e&"
import script from "./RatesForm.vue?vue&type=script&lang=js&"
export * from "./RatesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports